/**
 * Full width: a table or figure that spans both columns of a two-column document (2 Nov 2026,
 * the owner's screenshot: a wide table printed over the listing in the next column). The API has
 * read `span: "page"` since MCP-63 and prints it as table* / figure*, at the top of a page; only
 * the editor had no way to set it. Shown in two-column documents, and wherever it is already on so
 * it can be turned off. A table that is too wide and not set full width is shrunk to its column.
 */
import i18n from "i18next";
import { useEditorStore } from "@/store/editorStore";
import { testIds } from "@/testIds";

export function FullWidthSwitch({ value, onChange }: { value: boolean; onChange: (on: boolean) => void }) {
  const columns = useEditorStore((s) => s.document?.columns ?? 1);
  if (columns < 2 && !value) return null;
  return (
    <label style={{ display: "flex", gap: 8, alignItems: "flex-start", marginBottom: 12, fontSize: 13 }}>
      <input type="checkbox" data-testid={testIds.fullWidth} checked={value} onChange={(e) => onChange(e.target.checked)} style={{ marginTop: 3 }} />
      <span>
        <span style={{ fontWeight: 600 }}>{i18n.t("editor:fullWidth.label")}</span>
        <span style={{ display: "block", fontSize: 12, color: "var(--lilia-text-muted, #64748b)" }}>{i18n.t("editor:fullWidth.hint")}</span>
      </span>
    </label>
  );
}
